module.exports = __webpack_public_path__ + "img/App_icon@3x.b8245c76.png";